export default "__VITE_ASSET__C07J_55a__"